import React, { Component, useState } from "react";
import {
  GoogleMap,
  LoadScript,
  Marker,
  MarkerClusterer,
} from "@react-google-maps/api";
import {
  APIHandler,
  BackButton,
  PremiumHotel,
  FreeHotel,
  StorageHandler,
} from "C4";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import i18n from "i18n-react";
import { storageKeys } from "settings";

import { Multiselect } from "multiselect-react-dropdown";

import SimpleBarReact from "simplebar-react";
import "simplebar/src/simplebar.css";

import MarkerFree from "assets/images/ab-mapGrey.png";
import ClusterFree from "assets/images/ab-mapClusterGrey.png";
import MarkerPremium from "assets/images/ab-map.png";
import ClusterPremium from "assets/images/ab-mapCluster.png";
import logo from "assets/images/logo/logo_white.png";

let containerStyle = {
  width: "100%",
  height: "calc(100vh - 8rem)",
};
const params = new URLSearchParams(window.location.search);
if (params.get("mobile")) {
  containerStyle = {
    width: "100%",
    height: "100vh",
  };
}

const clusterPremium = {
  styles: [
    {
      url: ClusterPremium,
      width: 35,
      height: 51,
      textColor: "white",
      textSize: 14,
      fontFamily: "Source Sans Pro",
    },
  ],
  clusterClass: "clusterIcon",
};

const clusterFree = {
  styles: [
    {
      url: ClusterFree,
      width: 35,
      height: 51,
      textColor: "white",
      textSize: 14,
      fontFamily: "Source Sans Pro",
    },
  ],
  clusterClass: "clusterIcon",
};

const checkboxOptions = [
  { name: "Accessible Property", id: "accessibleProperty" },
  { name: "Beachfront", id: "beachfront" },
  { name: "Casino", id: "casino" },
  { name: "Dive Center", id: "diveCenter" },
  { name: "Fishing Lodge", id: "fishingLodge" },
  { name: "Golf", id: "golf" },
  { name: "Marina", id: "marina" },
  { name: "Self-Catering", id: "selfCatering" },
  { name: "Waterfront", id: "waterfront" },
];

export default class DirectoryView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      premiumHotelsList: [],
      freeHotelsList: [],
      lat1: 27.9180880264877,
      lat2: 21.587325646760732,
      lon1: -73.33094322972889,
      lon2: -78.95594322972889,
      loading: false,
      query: "",
      category: [],
      type: [],
      island: [],
      price: [],
      waterfront: "",
      beachfront: "",
      marina: "",
      selfCatering: "",
      accessibleProperty: "",
      golf: "",
      casino: "",
      diveCenter: "",
      fishingLodge: "",
      width: null,
      mobile: false,
      source: false,
      zoom: 6,
      lang: "en",
      center: {
        lat: 24.372665,
        lng: -77.299523,
      },
      color: "0096bb",
      font: "Source Sans Pro",
      userInfo: "",
      options: [
        { name: "Architecture, Arts, Culture & History", id: "category" },
        { name: "Airports", id: "category" },
        { name: "Breweries & Tap Rooms", id: "category" },
        { name: "Churches", id: "category" },
        { name: "Distillery & Tasting", id: "category" },
        { name: "Hotels", id: "category" },
        { name: "Meetings", id: "category" },
        { name: "Neighborhoods", id: "category" },
        { name: "Nightlife", id: "category" },
        { name: "Outdoor & Recreation", id: "category" },
        { name: "Restaurants", id: "category" },
        { name: "Restaurants with nightlife", id: "category" },
        { name: "Sports Venues", id: "category" },
        { name: "Tours", id: "category" },
      ],
      typeOptions: [
        { name: "Hotel", id: "type" },
        { name: "Resort", id: "type" },
        { name: "Lodge", id: "type" },
        { name: "All Inclusive", id: "type" },
        { name: "B&B", id: "type" },
        { name: "Guest House", id: "type" },
        { name: "Condo", id: "type" },
        { name: "Apartment Hotel", id: "type" },
        { name: "Boutique Hotel", id: "type" },
      ],
      islandOptions: [
        { name: "Abacos (The)", id: "island" },
        { name: "Acklins", id: "island" },
        { name: "Andros", id: "island" },
        { name: "Berry Islands (The)", id: "island" },
        { name: "Bimini", id: "island" },
        { name: "Cat Island", id: "island" },
        { name: "Crooked Island", id: "island" },
        { name: "Eleuthera & Harbour Island", id: "island" },
        { name: "Exumas (The)", id: "island" },
        { name: "Freeport/Grand Bahama Island", id: "island" },
        { name: "Inagua", id: "island" },
        { name: "Long Island", id: "island" },
        { name: "Mayaguana", id: "island" },
        { name: "Nassau & Paradise Island", id: "island" },
        { name: "San Salvador", id: "island" },
      ],
      priceOptions: [
        { name: "Budget", id: "price" },
        { name: "Budget+", id: "price" },
        { name: "Economy", id: "price" },
        { name: "Economy+", id: "price" },
        { name: "Moderate", id: "price" },
        { name: "Moderate+", id: "price" },
        { name: "Deluxe", id: "price" },
        { name: "Luxury", id: "price" },
      ],
      filterOpen: false,
    };

    this.onSelect = this.onSelect.bind(this);
    this.onRemove = this.onRemove.bind(this);
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    let mobile = false;
    if (params.get("mobile")) {
      mobile = true;
    }
    this.setState({ mobile: mobile, width: width });

    if (params.get("source")) {
      this.setState({ source: JSON.parse(params.get("source")) });
    }

    if (width < 800) {
      this.getHotelsList();
    }
  }

  handleInputChange = () => {
    this.setState(
      {
        query: this.search.value,
      },
      this.getHotelsList()
    );
  };

  loadProperties(bounds, zoom) {
    this.setState({
      lat1: bounds.getNorthEast().lat(),
      lat2: bounds.getSouthWest().lat(),
      lon1: bounds.getNorthEast().lng(),
      lon2: bounds.getSouthWest().lng(),
      zoom: zoom,
    });
    this.getHotelsList();
  }

  getHotelsList() {
    this.setState({ loading: true });

    // Language
    StorageHandler.load(storageKeys.lang).then((res) => {
      const country = res.code;
      this.setState({ lang: country });
    });

    setTimeout(() => {
      const {
        lat1,
        lat2,
        lon1,
        lon2,
        query,
        category,
        type,
        island,
        price,
        waterfront,
        beachfront,
        marina,
        selfCatering,
        accessibleProperty,
        golf,
        casino,
        diveCenter,
        fishingLodge,
      } = this.state;
      APIHandler.getFreeHotelsList(
        lat1,
        lat2,
        lon1,
        lon2,
        query,
        category,
        type,
        island,
        price,
        waterfront,
        beachfront,
        marina,
        selfCatering,
        accessibleProperty,
        golf,
        casino,
        diveCenter,
        fishingLodge
      ).then((results) => {
        this.setState({ freeHotelsList: results, loading: false });
      });
      APIHandler.getPremiumHotelsList(lat1, lat2, lon1, lon2).then(
        (results) => {
          this.setState({ premiumHotelsList: results.items });
        }
      );
    }, 200);
  }

  flyToMarker = (lat, lon) => {
    this.setState({
      zoom: 15,
      center: {
        lat: Number(lat),
        lng: Number(lon),
      },
    });
  };

  resetMap = () => {
    this.setState({
      zoom: 6,
      center: {
        lat: 24.372665,
        lng: -77.299523,
      },
    });
  };

  resetFilters = () => {
    window.location.reload(false);
  };

  premiumInfo = (userInfoID) => {
    const { lang } = this.state;
    if (this.state.mobile) {
      window.postMessage(
        `webview:https://travproconnect.com/profile/${userInfoID}?app_id=633&lang=${lang}`,
        "*"
      );
    } else {
      document.getElementById("iframe").classList.remove("hide");
      this.setState({
        userInfo: `https://travproconnect.com/profile/${userInfoID}?app_id=633&lang=${lang}`,
      });
    }
  };

  freeInfo = (userInfoID) => {
    const { lang } = this.state;
    if (this.state.mobile) {
      window.postMessage(
        `webview:https://travpro.yourworldapps.nl/profile-web.php?app_id=633&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=10&lang=${lang}`,
        "*"
      );
    } else {
      document.getElementById("iframe").classList.remove("hide");
      this.setState({
        userInfo: `https://travpro.yourworldapps.nl/profile-web.php?app_id=633&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=10&lang=${lang}`,
      });
    }
  };

  onSelect(selectedList, selectedItem) {
    this.setState(
      {
        [selectedItem.id]: [
          ...this.state[selectedItem.id],
          selectedItem["name"],
        ],
      },
      () => {
        this.getHotelsList();
      }
    );
  }

  onRemove(selectedList, removedItem) {
    const array = [...this.state[removedItem.id]];
    const index = array.indexOf(removedItem["name"]);
    if (index !== -1) {
      array.splice(index, 1);
      this.setState(
        {
          [removedItem.id]: array,
        },
        () => {
          this.getHotelsList();
        }
      );
    }
  }

  handleCheck = (e) => {
    if (this.state[e.target.id] === "") {
      this.setState(
        {
          [e.target.id]: 1,
        },
        () => {
          this.getHotelsList();
        }
      );
    } else {
      this.setState(
        {
          [e.target.id]: "",
        },
        () => {
          this.getHotelsList();
        }
      );
    }
  };

  closeIframe() {
    document.getElementById("iframe").classList.add("hide");
  }

  toggleFilter = () => {
    this.setState({
      filterOpen: !this.state.filterOpen,
    });
  };

  render() {
    const {
      premiumHotelsList,
      freeHotelsList,
      zoom,
      center,
      userInfo,
      mobile,
      width,
      loading,
      filterOpen,
      source,
    } = this.state;

    return (
      <div className="directoryContainer">
        {source && (
          <style>{".cookieConsent { display: none !important; } "}</style>
        )}
        {mobile && (
          <style>
            {
              "\
        .cookieConsent { display: none !important; } .directoryContainer { height: 100vh; } .results { top: 0 !important; } .listContainer { height: calc(100vh - 8rem) !important; }"
            }
          </style>
        )}
        {!mobile && (
          <div className="header">
            {!source && <BackButton useHistory={false} text="Back" />}
            <div className="search">
              <FontAwesomeIcon
                icon={["fas", "search"]}
                className="searchIcon"
              />
              <input
                className="searchInput"
                placeholder={i18n.translate("directory.search")}
                type="text"
                ref={(input) => (this.search = input)}
                onChange={this.handleInputChange}
              />
            </div>
            <img src={`/${logo}`} className="logo" alt="logo" />
          </div>
        )}
        <div className="directoryView">
          <div className="leftSide">
            <div className="results">
              {i18n.translate("directory.results")}:{" "}
              {freeHotelsList.length + premiumHotelsList.length}
              <button
                onClick={filterOpen ? this.toggleFilter : this.toggleFilter}
                className="filter-btn"
              >
                {filterOpen ? "Close" : "Filter"}
              </button>
            </div>
            <div className="leftGrid">
              <div className={`filterContainer ${filterOpen ? "active" : ""}`}>
                <div className="type">
                  <Multiselect
                    options={this.state.typeOptions}
                    selectedValues={this.state.selectedValue}
                    onSelect={this.onSelect}
                    onRemove={this.onRemove}
                    displayValue="name"
                    placeholder={i18n.translate("directory.acco")}
                    showArrow={true}
                    avoidHighlightFirstOption={true}
                  />
                </div>
                <div className="island">
                  <Multiselect
                    options={this.state.islandOptions}
                    selectedValues={this.state.selectedValue}
                    onSelect={this.onSelect}
                    onRemove={this.onRemove}
                    displayValue="name"
                    placeholder={i18n.translate("directory.island")}
                    showArrow={true}
                    avoidHighlightFirstOption={true}
                  />
                </div>
                <div className="price">
                  <Multiselect
                    options={this.state.priceOptions}
                    selectedValues={this.state.selectedValue}
                    onSelect={this.onSelect}
                    onRemove={this.onRemove}
                    displayValue="name"
                    placeholder={i18n.translate("directory.price")}
                    showArrow={true}
                    avoidHighlightFirstOption={true}
                  />
                </div>
                <div className="checkboxOptions">
                  <span className="title">
                    {i18n.translate("directory.additional")}
                  </span>
                  {checkboxOptions.map((option, index) => (
                    <div
                      key={index}
                      className="checkboxDiv"
                      id={option.id}
                      onClick={this.handleCheck}
                    >
                      <label id={option.id} onClick={this.handleCheck}>
                        <span
                          className="labelName"
                          id={option.id}
                          onClick={this.handleCheck}
                        >
                          {i18n.translate(
                            `directory.${option.name
                              .replace(/\s/g, "")
                              .replace(/&/g, "")
                              .replace(/,/g, "")
                              .replace(/&/g, "")
                              .replace(/,/g, "")
                              .replace(/-/g, "")
                              .replace("+", "")
                              .replace(/:/g, "")
                              .toLowerCase()}`
                          )}
                        </span>
                        <input
                          type="checkbox"
                          name={option.name}
                          onChange={this.handleCheck}
                        />
                        <span
                          className="checkmark"
                          id={option.id}
                          onClick={this.handleCheck}
                        />
                      </label>
                    </div>
                  ))}
                </div>
                <div
                  className="resetFilters"
                  onClick={() => {
                    this.resetFilters();
                  }}
                >
                  {i18n.translate("directory.reset")}
                </div>
                <div className="text-center">
                  <button
                    onClick={this.resetFilters}
                    className="filter-btn inverted"
                  >
                    {i18n.translate("directory.reset")}
                  </button>
                  <button onClick={this.toggleFilter} className="show-results">
                    {i18n.translate("directory.view")}
                  </button>
                </div>
              </div>

              <SimpleBarReact
                className={`listContainer ${filterOpen ? "filterOpen" : ""}`}
              >
                <div className="premiumList">
                  {loading && (
                    <span className="loader">
                      <FontAwesomeIcon icon={["fas", "circle-notch"]} spin />
                    </span>
                  )}
                  {premiumHotelsList.length > 0 &&
                    premiumHotelsList.map((hotel) => (
                      <PremiumHotel
                        key={hotel.id}
                        id={hotel.id}
                        bgImage={hotel.headerImages[0]}
                        propertyName={hotel.propertyName}
                        other={hotel}
                        flyToMarker={() => {
                          this.flyToMarker(
                            hotel.coords.latitude,
                            hotel.coords.longitude
                          );
                        }}
                        hotelInfo={() => {
                          this.premiumInfo(hotel.userInfoID);
                        }}
                      />
                    ))}
                </div>
                <div className="freeList">
                  {freeHotelsList.length === 0 && !loading && (
                    <div className="noResults">
                      {i18n.translate("directory.noResults")}
                    </div>
                  )}
                  {freeHotelsList.length > 0 &&
                    freeHotelsList.map((hotel) => (
                      <FreeHotel
                        key={hotel.company_listing_id}
                        id={hotel.company_listing_id}
                        bgImage={hotel.img_path}
                        flyToMarker={() => {
                          this.flyToMarker(hotel.latitude, hotel.longitude);
                        }}
                        hotelInfo={() => {
                          this.freeInfo(hotel.listing_id);
                        }}
                        hotelName={hotel.company}
                        location={hotel.state}
                        item={hotel}
                      />
                    ))}
                  {zoom > 8 && (
                    <div
                      className="resetMap"
                      onClick={() => {
                        this.resetMap();
                      }}
                    >
                      {"Reset Map to Start >"}
                    </div>
                  )}
                </div>
              </SimpleBarReact>
            </div>
          </div>
          {width > 700 && (
            <div className="rightSide">
              <LoadScript googleMapsApiKey="AIzaSyBpfyrBMTrgHH3YnaGHxfjEN_w7OXBJoqc">
                <GoogleMap
                  mapContainerStyle={containerStyle}
                  center={center}
                  zoom={zoom}
                  onLoad={(map) => {
                    this.map = map;
                  }}
                  onIdle={() => {
                    this.loadProperties(
                      this.map.getBounds(),
                      this.map.getZoom()
                    );
                  }}
                >
                  {/* Child components, such as markers, info windows, etc. */}
                  <MarkerClusterer
                    minimumClusterSize={4}
                    gridSize={100}
                    options={clusterFree}
                  >
                    {(clusterer) => {
                      return (
                        freeHotelsList.length > 0 &&
                        freeHotelsList.map((freeHotel) => (
                          <Marker
                            key={freeHotel.listing_id}
                            position={{
                              lat: Number(freeHotel.latitude),
                              lng: Number(freeHotel.longitude),
                            }}
                            icon={MarkerFree}
                            onClick={() => {
                              this.flyToMarker(
                                freeHotel.latitude,
                                freeHotel.longitude
                              );
                            }}
                            clusterer={clusterer}
                          />
                        ))
                      );
                    }}
                  </MarkerClusterer>
                  <MarkerClusterer
                    minimumClusterSize={5}
                    options={clusterPremium}
                  >
                    {(clusterer) => {
                      return (
                        premiumHotelsList.length > 0 &&
                        premiumHotelsList.map((premiumHotel) => (
                          <Marker
                            key={premiumHotel.id}
                            position={{
                              lat: premiumHotel.coords.latitude,
                              lng: premiumHotel.coords.longitude,
                            }}
                            icon={MarkerPremium}
                            onClick={() => {
                              this.flyToMarker(
                                premiumHotel.coords.latitude,
                                premiumHotel.coords.longitude
                              );
                            }}
                            clusterer={clusterer}
                          ></Marker>
                        ))
                      );
                    }}
                  </MarkerClusterer>
                </GoogleMap>
              </LoadScript>
            </div>
          )}

          <div className="iframe hide" id="iframe">
            <div
              className="bgIframe"
              onClick={() => {
                this.closeIframe();
              }}
            ></div>
            <div className="iframeHolder">
              <div
                className="closeIframe"
                href="#"
                onClick={() => {
                  this.closeIframe();
                }}
              >
                <span className="closeText">
                  <FontAwesomeIcon icon={["fas", "chevron-left"]} />{" "}
                  {i18n.translate("directory.back")}
                </span>
              </div>
              <div
                className="contentIframe"
                style={{ backgroundColor: "white" }}
              >
                <iframe
                  width="100%"
                  height="100%"
                  id="iframeModal"
                  src={userInfo}
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
